function productSlider() {
  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    autoHeight: true,
    dots: false,
    responsive: {
      0: {
        items: 5,
      },
      600: {
        items: 4,
      },
      1000: {
        items: 6,
      },
    },
  });
}
$(document).ready(function () {
  productSlider();
});
